import React from "react";
import {useGetAssetsInfiniteQuery, useGetAssetsQuery} from "hooks";
import ImageTypeList from "components/Layout/components/ObjectPanel/ImageTypeList";
import ListTypeList from "components/Layout/components/ObjectPanel/ListTypeList";
import {ASSET_LIST_TYPE, ASSET_TYPE, ASSET_PARAMS, ASSET_KEYWORD_LIST} from "components/Layout/constants";
import styles from "./index.module.scss";
import PerspectiveCameraThumbnail from "assets/image/Layout/ObjectPanel/Layer/ic_perspective_camera.svg"; // [TEMP]
import OrthographicCameraThumbnail from "assets/image/Layout/ObjectPanel/Layer/ic_orthographic_camera.svg"; // [TEMP]

export default function AssetTab() {
  const {data: lightAssets} = useGetAssetsQuery(ASSET_TYPE.LIGHT, ASSET_PARAMS.LIGHT, 2);
  const {data: soundAssets} = useGetAssetsQuery(ASSET_TYPE.SOUND, ASSET_PARAMS.SOUND, 2);
  let {data: cameraAssets} = useGetAssetsQuery(ASSET_TYPE.CAMERA, ASSET_PARAMS.CAMERA, 2);
  // [TEMP]
  if (cameraAssets.length === 0) {
    cameraAssets = [
      {name: "perspective", thumbnailUrl: PerspectiveCameraThumbnail, topCategory: "MODEL", midCategory: "CAMERA", subCategory: null},
      {name: "orthographic", thumbnailUrl: OrthographicCameraThumbnail, topCategory: "MODEL", midCategory: "CAMERA", subCategory: null},
    ];
  }

  return (
    <div className={styles.container}>
      <ListTypeList title="Camera" type={ASSET_TYPE.CAMERA} assetSearchParams={ASSET_PARAMS.CAMERA} data={cameraAssets} />
      {ASSET_KEYWORD_LIST.map((keyword, index) => (
        <ListWrapperForQuery keyword={keyword} key={index} />
      ))}
      <ListTypeList title="Light" type={ASSET_TYPE.LIGHT} assetSearchParams={ASSET_PARAMS.LIGHT} data={lightAssets} />
      <ListTypeList title="Sound" type={ASSET_TYPE.SOUND} assetSearchParams={ASSET_PARAMS.SOUND} data={soundAssets} />
    </div>
  );
}

function ListWrapperForQuery({keyword}) {
  const {data, fetchNextPage, hasNextPage} = useGetAssetsInfiniteQuery(ASSET_PARAMS[keyword.name.toUpperCase().replace(" ", "")]);
  return (
    <ImageTypeList
      title={keyword.name}
      type={ASSET_TYPE[keyword.name.toUpperCase().replace(" ", "")]}
      assetSearchParams={ASSET_PARAMS[keyword.name.toUpperCase().replace(" ", "")]}
      listType={ASSET_LIST_TYPE[keyword.type]}
      data={data}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
    />
  );
}
